<div class="close-button" (click)="closeDialog()"></div>
<div class="scrollable">

  <!-- To vote -->
  <ng-template [ngIf]="!isVoted">

    <!-- yellow header -->
    <div class="top-info" [ngStyle]="backgroundImageWithGradient">
      <div class="name" [class.crossed]="stopSupportingConfirmed">{{projectInfo?.name[currentLanguage]}}</div>
      <div class="location">{{"PREFERENCES_POPUP_2." + projectInfo?.continent + "_preferencespopup2" | translate }} - {{"COUNTRIES." + projectInfo?.country | translate}}</div>
      <div class="tip d-none d-md-block">{{ "PREFERENCES_POPUP_1." + projectInfo?.north_star + "_preferencespopup1" | translate }}</div>
    </div>

    <!--  For Vote dialog (10A)-->
    <ng-template [ngIf]="votesLeft > 0 && isPledge && !stopSupporting && !stopSupportingConfirmed">

      <div class="bottom-info">
        <div class="remaining-votes-container">
          <span class="votes-text">{{ "VOTE_MODAL.have_votemodal" | translate }} <span>{{votesLeft}}</span> {{ "VOTE_MODAL.remaining_votemodal" | translate }}</span>
          <span class="votes-icon-container">
            <span class="vote-icon" *ngFor="let i of [].constructor(votesLeft)">
              <span class="icon supported"></span>
            </span>
          </span>
        </div>

        <div class="buttons-container">
          <button class="yellow with-bird serif" (click)="voteProject(projectInfo.id)">
            <span class="flash"><img loading="lazy" src="/assets/icons/flash.svg" alt="bird"></span>
            <span>{{ "VOTE_MODAL.give_vote_votemodal" | translate }} <br class="d-inline d-md-none">{{ "VOTE_MODAL.one_vote_votemodal" | translate }}</span>
          </button>
        </div>

        <div class="bottom-message">
          {{ "VOTE_MODAL.have_future_votemodal" | translate }} {{votesLeft - 1}} {{ "VOTE_MODAL.remaining_future_votemodal" | translate }}<br>
          {{ "VOTE_MODAL.month_after_votemodal" | translate }} {{ companyName }}
        </div>
      </div>
    </ng-template>

    <!--  For dialog no votes remaining (10D)-->
    <ng-template [ngIf]="votesLeft === 0 && isPledge && !stopSupporting && !stopSupportingConfirmed">
      <div class="bottom-info" style="padding: 0 0 50px 0">
        <div class="no-votes-message">
          <span>{{ "NO_VOTE_REMAINING.already_novoteremaining" | translate }}</span>
        </div>
        <div class="alternative-message">
          {{ "NO_VOTE_REMAINING.can_novoteremaining" | translate }} <span>{{ "NO_VOTE_REMAINING.need_novoteremaining" | translate }}</span> {{ "NO_VOTE_REMAINING.from_novoteremaining" | translate }}<br>
          {{ "NO_VOTE_REMAINING.alternatively_novoteremaining" | translate }}
        </div>
        <div class="reclaim-button-wrapper column">
          <button class="yellow sans-serif" (click)="reclaimVote()">
            <span>{{ "NO_VOTE_REMAINING.cta_novoteremaining" | translate }}</span>
          </button>
          <button class="donate-button sans-serif with-bird yellow" (click)="openOneTimeDonation()">
            <span class="custom-bird"><img loading="lazy" src="/assets/icons/colibri-very-dark-grey.svg" alt="bird"></span>
            <span>{{ "VOTE_MODAL.subscription_votemodal" | translate }}</span>
          </button>
        </div>
      </div>
    </ng-template>

    <!--  For vote dialog public users-->
    <ng-template [ngIf]="!isPledge && !stopSupporting && !stopSupportingConfirmed">
      <div class="bottom-info" style="padding: 0 0 50px 0">
        <div class="alternative-message" style="margin-top: 45px">
          {{ "DONATE_MODAL_PUBLIC.funded_donatemodalpublic" | translate }}
        </div>
        <div class="add-to-funded-wrapper">
          <button class="yellow serif with-bird" (click)="voteProject(projectInfo.id)">
            <span class="bird"><img loading="lazy" src="/assets/icons/colibri-very-dark-grey.svg" alt="bird"></span>
            <span>{{ "DONATE_MODAL_PUBLIC.add1_donatemodalpublic" | translate }}</span>
          </button>
        </div>
      </div>
    </ng-template>
  </ng-template>
  <!-- To unvote or thank you page -->
  <ng-template [ngIf]="isVoted">
    <!-- yellow header -->
    <ng-template [ngIf]="stopSupporting || stopSupportingConfirmed">
      <div class="top-info" [ngStyle]="backgroundImageWithGradient">
        <div class="name" [class.crossed]="stopSupportingConfirmed">{{projectInfo?.name[currentLanguage]}}</div>
        <div class="location">{{"PREFERENCES_POPUP_2." + projectInfo?.continent + "_preferencespopup2" | translate }} - {{"COUNTRIES." + projectInfo?.country | translate}}</div>
        <div class="tip d-none d-md-block">{{ "PREFERENCES_POPUP_1." + projectInfo?.north_star + "_preferencespopup1" | translate }}</div>
      </div>
    </ng-template>

    <!-- For dialog with already voted project -->
    <ng-template [ngIf]="!stopSupporting && !stopSupportingConfirmed">
      <div class="voted-top">
        <div class="voted-logo">
          <img loading="lazy" src="/assets/icons/power-no-size.svg" alt="power">
        </div>
          <div class="voted-great">
            {{ "VOTE_MODAL.great_votemodal" | translate }}
          </div>
          <div class="voted-span">
            {{ "VOTE_MODAL.already_votemodal" | translate }}
          </div>
        <button class="voted-share" [appTooltip]="projectInfo.slug" [shareType]="{type: rootShare}"><img loading="lazy" src="/assets/icons/share-dark-blue.svg" alt="pin"></button>
      </div>
      <div class="voted-bottom">
        <div class="voted-more">
          {{ "VOTE_MODAL.more_votemodal" | translate }}
        </div>
        <ng-template [ngIf]="!isSubscription">
          <button class="with-bird" (click)="openOneTimeDonation()">
            <span class="bird"><img loading="lazy" src="/assets/icons/colibri-very-dark-grey.svg" alt="bird"></span>
            <span>{{ "VOTE_MODAL.subscription_votemodal" | translate }}</span>
          </button>
        </ng-template>
        <ng-template [ngIf]="isSubscription">
          <button class="with-bird" (click)="openOneTimeDonation()">
            <span class="bird"><img loading="lazy" src="/assets/icons/colibri-very-dark-grey.svg" alt="bird"></span>
            <span>{{ "VOTE_MODAL.donate2_votemodal" | translate }}</span>
          </button>
        </ng-template>
      </div>
    </ng-template>

    <!--  For dialog Stop supporting (10K)-->
    <ng-template [ngIf]="stopSupporting && !stopSupportingConfirmed">
      <div class="bottom-info" style="padding: 0 0 50px 0">
        <div class="no-votes-message">
          <span>{{ "UNSUPPORT_PUBLIC.banner_unsupportpublic" | translate }}</span>
        </div>
        <div class="alternative-message">
          {{ "UNSUPPORT_PUBLIC.subtitle_unsupportpublic" | translate }}
        </div>
        <div class="reclaim-button-wrapper">
          <button class="yellow sans-serif" (click)="unvoteProject(projectInfo.id)">
            <span>{{ "UNSUPPORT_PUBLIC.cta_unsupportpublic" | translate }}</span>
          </button>
          <a class="link" (click)="closeDialog()">{{ "UNSUPPORT_PUBLIC.wait_unsupportpublic" | translate }}</a>
        </div>
      </div>
    </ng-template>

    <!--  For dialog Stop supporting confirmation (10L)-->
    <ng-template [ngIf]="stopSupportingConfirmed">
      <div class="bottom-info" style="padding: 0 0 50px 0">
        <div class="no-votes-message">
          <span>{{ "UNSUPPORT_CONFIRMATION.banner_unsupportconfirmation" | translate }}</span>
        </div>
        <div class="alternative-message">
          {{ "UNSUPPORT_CONFIRMATION.subtitle_unsupportconfirmation" | translate }}
        </div>
        <div class="reclaim-button-wrapper">
          <button class="yellow sans-serif" (click)="navigateToBrowseProjects()">
            <span>{{ "UNSUPPORT_CONFIRMATION.cta_unsupportconfirmation" | translate }}</span>
          </button>
        </div>
      </div>
    </ng-template>
  </ng-template>

</div>


